import { z } from 'zod';
export const EntityKind = z.enum(['company', 'entrepreneur']);
// «Иванов Иван Иванович» → «Иванов И. И.». Фамилия (1-е слово) остаётся как есть,
// остальные слова сокращаются до инициала с точкой. Для ФИО в род. падеже инициалы
// верны (Татьяны→Т.), но фамилия может склониться — тогда нужен ручной directorShort.
export function shortenName(fullName) {
    if (!fullName)
        return null;
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return null;
    const [surname, ...rest] = parts;
    if (rest.length === 0)
        return surname;
    // Между инициалами — обычный пробел: «Фамилия И. О.».
    const initials = rest.map((w) => `${w[0].toUpperCase()}.`).join(' ');
    return `${surname} ${initials}`;
}
export const CONTRACT_FIELD_LABELS = {
    entityKind: 'Тип (ООО/ИП)',
    name: 'Наименование',
    inn: 'ИНН',
    ogrn: 'ОГРН/ОГРНИП',
    kpp: 'КПП',
    legalAddress: 'Юридический адрес',
    directorName: 'ФИО директора',
    directorTitle: 'Должность подписанта',
    signatoryBasis: 'Основание полномочий',
    bankName: 'Банк',
    bankAccount: 'Расчётный счёт',
    bankCorr: 'Корр. счёт',
    bankBik: 'БИК',
    paymentDelay: 'Отсрочка оплаты (дни)',
};
// Возвращает массив ключей незаполненных обязательных полей.
export function missingContractFields(r) {
    const common = ['name', 'inn', 'ogrn', 'legalAddress',
        'bankName', 'bankAccount', 'bankCorr', 'bankBik', 'paymentDelay'];
    const companyOnly = ['kpp', 'directorName', 'directorTitle', 'signatoryBasis'];
    const need = [...common];
    if (r.entityKind === 'company')
        need.push(...companyOnly);
    if (!r.entityKind)
        return ['entityKind', ...need];
    const missing = [];
    for (const k of need) {
        const v = r[k];
        if (v === null || v === undefined || v === '')
            missing.push(k);
    }
    return missing;
}
//# sourceMappingURL=contracts.js.map